import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import {bindActionCreators} from 'redux';  
import { connect } from 'react-redux';
import { userActions } from './_actions';
import { getCurrentUser, signOut } from './Cognito'

class UserStatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: null,
    }
  }

  componentDidMount () {
		this.props.actions.getUser();
		if (this.props.attributes.length === 0){
			this.props.actions.getUserAttributes();
		}

    getCurrentUser(attributes => {
      for (let i = 0; i < attributes.length; i++) {
        if (attributes[i].Name === 'email') {
          this.setState({ email: attributes[i].Value })
        }
      }
    })
  }

	handleSignout() {
		this.props.dispatch(userActions.logout());
	}

  render () {
		const { attributes } = this.props;
		const { authentication } = this.props;
    return (
			<div>
				{ attributes && attributes.name &&
				<h2>Hello { attributes.name }</h2>}
				{ attributes && attributes.email &&
					<span>{ attributes.email }</span>}
      	{authentication && authentication.loggedIn && <RaisedButton onClick={signOut}>Sign out</RaisedButton>}
			</div>
    )
  }
}

function mapStateToProps(state) {
		const { user } = state;
		const { attributes } = user;
		const { authentication } = state;
		return {
			user,
			attributes,
			authentication
		}
}

function mapDispatchToProps(dispatch) {  
  return {
		actions: bindActionCreators(userActions, dispatch)
	}
}


const userStatus = connect(mapStateToProps, mapDispatchToProps)(UserStatus);

export default userStatus



// WEBPACK FOOTER //
// ./src/UserStatus.jsx